<template>
  <div class="pages">
    <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
      style="z-index: 999"
    />
    <div class="headerTop">
      <div class="headerTabbar" v-if="ismeals">
        <van-tabs v-model="tabActive">
          <van-tab
            v-for="(item, index) in meals"
            :key="index"
            :title="item.name"
            :value="item.value"
          >
            <template #title>
              <!-- {{item.name}} -->
              <div
                :class="
                  item.value !== tabActive
                    ? 'headerTabbar-titlebar'
                    : 'headerTabbar-isactive'
                "
              >
                {{ item.name }}
              </div>
            </template>
          </van-tab>
        </van-tabs>
      </div>
      <div id="chart" class="chart" v-show="tabActive == 0"></div>
      <div v-show="tabActive != 0" class="headerTop-circle">
        <div class="headerTop-content-text">
          <div class="text-title">还可以吃</div>
          <div class="text-num">{{ parseInt(ResidualIntake) }}</div>
          <div class="text-pricetext">推荐预算</div>
          <div class="text-pricetext">{{ recommendIntake }}</div>
        </div>
        <div class="headerTop-content-circle">
          <van-circle
            v-model="currentRate"
            :rate="rate"
            :clockwise="false"
            layer-color="#E7EEFA"
            color="#C4D4F2"
            size="40vw"
            stroke-width="60"
          >
          </van-circle>
        </div>
      </div>
      <div v-if="isprogressBar">
        <progressBar
          v-if="breakfastArr && breakfastArr.length"
          :name="'早餐'"
          :number="breakfastArr[0].netContent"
          :units="breakfastArr[0].unit"
          :max="breakfastArr[0].lessValue"
          :min="breakfastArr[0].greaterValue"
        />
        <progressBar
          v-if="lunchArr && lunchArr.length"
          :name="'午餐'"
          :number="lunchArr[0].netContent"
          :units="lunchArr[0].unit"
          :max="lunchArr[0].lessValue"
          :min="lunchArr[0].greaterValue"
        />
        <progressBar
          v-if="dinnerArr && dinnerArr.length"
          :name="'晚餐'"
          :number="dinnerArr[0].netContent"
          :units="dinnerArr[0].unit"
          :max="dinnerArr[0].lessValue"
          :min="dinnerArr[0].greaterValue"
        />
      </div>
    </div>
    <div class="headerTop">
      <div class="headerTop-title">三大营养元素分析</div>
      <div v-if="isprogressBar">
        <div v-for="(item, index) in nutriList" :key="index">
          <progressBar
            v-if="item.name != '热量'"
            :name="item.name"
            :number="item.netContent"
            :units="item.unit"
            :min="item.greaterValue"
            :max="item.lessValue"
          />
        </div>
      </div>
    </div>
    <div class="headerTop">
      <div class="headerTop-title">微量元素</div>

      <div v-if="isprogressBar">
        <div v-for="(item, index) in nutriSpliceList" :key="index">
          <progressBar
            :name="item.name"
            :number="item.netContent"
            :units="item.unit"
            :min="item.greaterValue"
            :max="item.lessValue"
          />
        </div>
      </div>
    </div>
    <div style="height: 10px"></div>
  </div>
</template>

<script>
import progressBar from "./components/progressBar.vue";
export default {
  components: {
    progressBar,
  },
  data() {
    return {
      userData: {},
      meals: [],
      tabActive: 0, //首页tab
      currentRate: 0,
      rate: 0,
      ResidualIntake: 0, //剩余可摄入量
      recommendIntake: 0, //推荐摄入量
      tabList: [
        { label: "全部", value: 0 },
        { label: "早餐", value: 1 },
        { label: "午餐", value: 2 },
        { label: "晚餐", value: 3 },
      ],
      wholeDayDetail: [], //全天
      breakfastDetail: [], //早餐
      lunchDetail: [], //午餐
      dinnerDetail: [], //晚餐

      wholeArr: [],
      breakfastArr: [],
      lunchArr: [],
      dinnerArr: [],

      wholespliceArr: [],
      breakfastspliceArr: [],
      lunchspliceArr: [],
      dinnerspliceArr: [],

      isprogressBar: false,
      nutriList: [],
      nutriSpliceList: [],
      ismeals: false,
      customerId: "",
    };
  },
  watch: {
    tabActive() {
      let arr = [
        this.wholeArr,
        this.breakfastArr,
        this.lunchArr,
        this.dinnerArr,
      ];
      let brr = [
        this.wholespliceArr,
        this.breakfastspliceArr,
        this.lunchspliceArr,
        this.dinnerspliceArr,
      ];
      this.nutriList = arr[this.meals[this.tabActive].value];
      this.nutriSpliceList = brr[this.meals[this.tabActive].value];
      let obj = this.meals[this.tabActive];
      console.log(obj, 170);
      this.ResidualIntake = obj.suggestEngine - obj.engine;
      // 剩余可摄入量不为负数
      this.ResidualIntake < 0 ? (this.ResidualIntake = 0) : "";
      // 剩余可摄入量 占比
      this.ResidualIntake
        ? (this.rate = (this.ResidualIntake / obj.suggestEngine) * 100)
        : (this.rate = 0);
      this.recommendIntake = obj.suggestEngine;
    },
  },
  mounted() {
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    this.customerId =
      (roles && roles[0].customerId) || localStorage.getItem("customerId") || 0;
    this.getUserHomePageView();
    this.getUserDayIngestionCheck();
  },
  methods: {
    getUserHomePageView() {
      this.$logina
        .post("/nutrients/ai/api/userHomePageView", {
          userCode: this.customerId,
        })
        .then((res) => {
          this.userData = res.data.data; //用户数据
          this.meals = this.userData.meals;
          this.meals.unshift({
            suggestEngine: this.userData.suggestEngine,
            engine: this.userData.suggestEngine,
            name: "全部",
            value: 0,
          });
          for (let i = 0; i < this.meals.length; i++) {
            this.meals[i].name == "早餐" ? (this.meals[i].value = 1) : "";
            this.meals[i].name == "午餐" ? (this.meals[i].value = 2) : "";
            this.meals[i].name == "晚餐" ? (this.meals[i].value = 3) : "";
          }
          console.log(this.meals, 202);
          this.ismeals = true;
        });
    },
    getUserDayIngestionCheck() {
      this.$logina
        .post("/nutrients/ai/api/userDayIngestionCheck", {
          userCode: this.customerId,
          queryDate: this.dayjs(new Date()).format("YYYY-MM-DD"),
        })
        .then((res) => {
          const Arrdata = res.data.data;
          this.wholeDayDetail = this.dataListFun(Arrdata.wholeDayDetail);
          this.breakfastDetail = this.dataListFun(Arrdata.breakfastDetail);
          this.lunchDetail = this.dataListFun(Arrdata.lunchDetail);
          this.dinnerDetail = this.dataListFun(Arrdata.dinnerDetail);
        })
        .then((res) => {
          this.wholeArr = this.datamapFun(this.wholeDayDetail);
          this.breakfastArr = this.datamapFun(this.breakfastDetail);
          this.lunchArr = this.datamapFun(this.lunchDetail);
          this.dinnerArr = this.datamapFun(this.dinnerDetail);

          this.wholespliceArr = this.dataspliceFun(this.wholeDayDetail);
          this.breakfastspliceArr = this.dataspliceFun(this.breakfastDetail);
          this.lunchspliceArr = this.dataspliceFun(this.lunchDetail);
          this.dinnerspliceArr = this.dataspliceFun(this.dinnerDetail);
        })
        .then((res) => {
          try {
            this.nutriList = this.wholeArr;
            this.nutriSpliceList = this.wholespliceArr;
            let charts = document.getElementById("chart");
            let obj = {
              breakfast: 0,
              lunch: 0,
              dinner: 0,
            };
            if (this.breakfastArr && this.breakfastArr.length != 0) {
              obj.breakfast = this.breakfastArr[0].netContent;
            }
            if (this.lunchArr && this.lunchArr.length != 0) {
              obj.lunch = this.lunchArr[0].netContent;
            }
            if (this.dinnerArr && this.dinnerArr.length != 0) {
              obj.dinner = this.dinnerArr[0].netContent;
            }
            this.getEcharts(charts, obj.breakfast, obj.lunch, obj.dinner);
          } catch (error) {
            let charts = document.getElementById("chart");
            this.getEcharts(charts, 0, 0, 0);
          }
        })
        .then((res) => {
          this.isprogressBar = true;
        });
    },
    dataspliceFun(arr) {
      if (!arr) {
        return [];
      }
      let i = arr.length;
      while (i--) {
        if (
          arr[i].name == "热量" ||
          arr[i].name == "碳水化合物" ||
          arr[i].name == "蛋白质" ||
          arr[i].name == "脂肪"
        ) {
          arr.splice(i, 1);
        }
      }
      return arr;
    },
    datamapFun(dataList) {
      if (dataList == null) {
        return [];
      }
      let arr = [];
      dataList.map((item, index) => {
        item.name == "热量" ? ((arr[0] = item), (arr[0].inedx = index)) : "";
        item.name == "碳水化合物"
          ? ((arr[1] = item), (arr[1].inedx = index))
          : "";
        item.name == "蛋白质" ? ((arr[2] = item), (arr[2].inedx = index)) : "";
        item.name == "脂肪" ? ((arr[3] = item), (arr[3].inedx = index)) : "";
      });
      return arr;
    },
    dataListFun(Arrdata) {
      if (Arrdata == null) {
        return null;
      }
      // 已摄入  摄入标准
      let nutrients = Arrdata.nutrients;
      let IntakeStandard = Arrdata.userHealthyProfile.nutrientsConfigs;
      for (let i = 0; i < nutrients.length; i++) {
        nutrients[i].greaterValue = 0;
        nutrients[i].lessValue = 0;
        for (let j = 0; j < IntakeStandard.length; j++) {
          if (nutrients[i].code == IntakeStandard[j].nutrientsCode) {
            nutrients[i].greaterValue = IntakeStandard[j].greaterValue;
            nutrients[i].lessValue = IntakeStandard[j].lessValue;
          }
        }
      }
      return nutrients;
    },
    getEcharts(chart, breakfast, lunch, dinner) {
      let myChart = this.$echarts.init(chart);
      let option = {
        textStyle: {
          show: false,
        },
        color: ["#FFB13B", "#0FCAFD", "#75FBC3"],
        series: [
          {
            type: "pie",
            selectedMode: "single",
            radius: [0, "75%"],
            label: {
              normal: {
                show: true,
                formatter: "{b}\n{d}%",
                position: "outside",
              },
            },
            itemStyle: {
              normal: {
                borderColor: "#ffffff",
                borderWidth: 8,
              },
            },
            data: [
              { value: breakfast, name: "早餐" },
              { value: lunch, name: "午餐" },
              { value: dinner, name: "晚餐" },
            ],
          },
        ],
      };
      option && myChart.setOption(option);
    },
  },
};
</script>
<style scoped>
::v-deep .van-tabs__line {
  position: absolute;
  width: 36px;
  height: 6px;
  background: #fbd561;
  border-radius: 4px 4px 4px 4px;
}
</style>
<style lang="less" scoped>
.pages {
  padding-top: 55px;
}
.headerTabbar {
  position: relative;
  &-titlebar {
    font-size: 15px;
    font-weight: 300;
    color: #909090;
  }
  &-isactive {
    font-size: 17px;
    font-weight: bold;
    color: #202020;
  }
}
.headerTop {
  width: 343px;
  margin: 0 auto;
  padding: 15px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background: #ffffff;
  position: relative;
  border-radius: 8px 8px 8px 8px;
  box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.1);
  &-title {
    font-size: 17px;
    font-family: "HarmonyOS Sans SC-Regular, HarmonyOS Sans SC";
    font-weight: 400;
    color: #202020;
    position: relative;
  }
  &-title::before {
    content: "";
    height: 16px;
    width: 2px;
    background-color: #4bd891;
    position: absolute;
    left: -7px;
    top: 3px;
  }
  .chart {
    min-width: 200px;
    min-height: 200px;
    box-sizing: border-box;
  }
  &-circle {
    width: 150px;
    margin: 30px auto;
    position: relative;
    padding-top: 20px;
  }
  &-content {
    &-circle {
      position: absolute;
      top: 0px;
    }
    &-text {
      text-align: center;
      .text-title {
        font-size: 16px;
        font-family: "HarmonyOS Sans SC-Light, HarmonyOS Sans SC";
        font-weight: 300;
        color: #606060;
        line-height: 22px;
      }
      .text-num {
        font-size: 30px;
        font-family: "HarmonyOS Sans SC-Bold, HarmonyOS Sans SC";
        font-weight: bold;
        color: #606060;
        line-height: 50px;
      }
      .text-pricetext {
        font-size: 10px;
        font-family: "HarmonyOS Sans SC-Light, HarmonyOS Sans SC";
        font-weight: 300;
        color: #606060;
      }
    }
    &-number {
      text-align: center;
      .number-title {
        margin-top: 20px;
        font-size: 20px;
        font-family: "HarmonyOS Sans SC-Light, HarmonyOS Sans SC";
        font-weight: 300;
        color: #606060;
        line-height: 33px;
      }
      .number-num {
        margin-top: 10px;
        font-size: 40px;
        font-family: "HarmonyOS Sans SC-Medium, HarmonyOS Sans SC";
        font-weight: 500;
        color: #606060;
        line-height: 47px;
      }
    }
  }
  &-content > div {
    width: 50%;
  }
}
</style>